module.exports = __webpack_public_path__ + "img/yuan1.5b590dfe.png";